import { Eyebrow } from '../concept/eyebrow';

/**
 * One of the four figures across the top of the coach overview.
 *
 * The reference deck colour-codes these blue / red / amber / green down the
 * left edge. That is the traffic light the concept drops, and for the reason
 * the accessibility work established — four hues in one band cannot be made
 * to separate. The emphasis that survives is sage for the one tile a coach is
 * meant to act on, and ink for the rest, so exactly one thing pulls the eye.
 */
export const KpiTile: React.FC<{
  label: string;
  value: number | string;
  caption: string;
  /** The tile that carries the next action. At most one. */
  accent?: boolean;
  onClick?: () => void;
  testId?: string;
}> = ({ label, value, caption, accent, onClick, testId }) => {
  const Tag = onClick ? 'button' : 'div';
  return (
    <Tag
      {...(onClick ? { type: 'button' as const, onClick } : {})}
      data-testid={testId}
      className={`flex flex-col gap-2 rounded-lg border p-5 text-left transition-colors ${
        accent ? 'border-primary bg-accent' : 'border-border bg-card'
      } ${onClick ? 'hover:border-primary' : ''}`}
    >
      <Eyebrow tone={accent ? 'primary' : 'muted'}>{label}</Eyebrow>
      <div className="flex items-baseline gap-2">
        <span className="tabular text-[26px] font-semibold leading-none tracking-[-0.02em]">
          {value}
        </span>
        <span className="text-[11px] text-muted-foreground">{caption}</span>
      </div>
    </Tag>
  );
};
